import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { PopupsForAddingState, PopupsState, ReturnedPortfolio } from '../Create-Portfolio/types';
import '../Preview/Preview.css';
import {
  useFileAmountValidation,
  // useFileSizeValidation,
} from '../Create-Portfolio/customHooks';
import { validationMessages } from '../../config/validationMessages';
import { handleNewItemFields } from '../UserProfile/helpers';
import { newlyAddedProject } from '../Create-Portfolio/initialValues';
import FileUploadComponent from '../FileUploadButton/SingleFileUploadButton';
//import { ReactComponent as DeleteIcon } from '../../images/trash3-fill.svg';
import { v4 as uuidv4 } from 'uuid';
import { API_ROUTES } from '../../config/api-routes';
import axiosInstance from '../../api/api';
import { toast } from 'react-toastify';
import { normalizeUrl } from '../Preview/helpers';
import { refreshPortfolioAfterSave, type PortfolioGetDataFn } from '../../utils/portfolioRefresh';
import { resolveProjectVisibility } from '../../utils/promptVisibilityMeta';
import type { PromptVisibility } from '../Prompts/promptsV2Types';
import { VisibilitySelectDropdown } from '../Prompts/VisibilitySelectDropdown';

type ProjectFile = string | { name: string; tempFile: File };

interface Props {
  portfolioId?: number;
  index: number;
  portfolio: ReturnedPortfolio;
  setOpenedPopups: React.Dispatch<React.SetStateAction<PopupsState>>;
  setPopupsToAdd: React.Dispatch<React.SetStateAction<PopupsForAddingState>>;
  setPortfolioData: React.Dispatch<React.SetStateAction<ReturnedPortfolio>>;
  setSavePortfolioButton: React.Dispatch<React.SetStateAction<boolean>>;
  savePortfolioButton: boolean;
  popupVariant: string;
  getData?: PortfolioGetDataFn;
}

interface Project {
  id?: string | number;
  name: string;
  description?: string;
  filesUrl: ProjectFile[];
  visibility?: PromptVisibility | string;
  isHiddenOnPublic?: boolean;
  is_hidden_on_public?: boolean;
}

function setProjectVisibility(project: Project, visibility: PromptVisibility): Project {
  const hidden = visibility !== 'public';
  return {
    ...project,
    visibility,
    isHiddenOnPublic: hidden,
    is_hidden_on_public: hidden,
  };
}

function ProjectVisibilityField({
  value,
  onChange,
}: {
  value: PromptVisibility;
  onChange: (next: PromptVisibility) => void;
}) {
  return (
    <VisibilitySelectDropdown
      value={value}
      onChange={onChange}
      itemLabel="project"
      label="Who can view this project?"
    />
  );
}

const ProjectsPopup: React.FC<Props> = ({
  portfolioId,
  portfolio,
  setOpenedPopups,
  setPopupsToAdd,
  setPortfolioData,
  setSavePortfolioButton,
  savePortfolioButton,
  index,
  popupVariant,
  getData,
}) => {
  //console.log('ProjectsPopup portfolio:', portfolio?.id, portfolio);
  const [projects, setProjects] = useState<Project[]>(portfolio.projects as Project[]);
  const [project, setNewProject] = useState<any>(newlyAddedProject);
  const [disabled, setDisabled] = useState<boolean>(true);
  // const [success, setAddingFileSuccess] = useState<boolean>(false);
  const [sizeError, setSizeError] = useState<boolean>(false);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const popupRef = useRef<HTMLDivElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadDisabled, setUploadDisabled] = useState<Record<number, boolean>>({});

  const { fileError } = useFileAmountValidation(projects[index]?.filesUrl, index);

  // const errorWithSizeInNewProject = useFileSizeValidation(
  //   project.filesUrl,
  //   index,
  // );

  // const errorWithAmountInNewProject = useFileAmountValidation(
  //   project.filesUrl,
  //   index,
  // );

  useEffect(() => {
    setProjects(portfolio.projects as Project[]);
  }, [portfolio.projects]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        // setPopupsToAdd((prev: PopupsForAddingState) => ({
        //   ...prev,
        //   projects: false,
        // }));
        // setOpenedPopups((prev) => {
        //   const newProjectsPopups = [...prev.projects];
        //   newProjectsPopups[index] = false;
        //   return {
        //     ...prev,
        //     projects: newProjectsPopups,
        //   };
        // });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupRef, setOpenedPopups, setPopupsToAdd, index]);

  useEffect(() => {
    setProjects(portfolio.projects as Project[]);
  }, [portfolio.projects]);

  const handleSelectFileForNew = (file: File) => {
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (file.size >= maxSizeInBytes) {
      setSizeError(true);
      return;
    }

    setPendingFiles((prev) => [...prev, file]);
    setSizeError(false);
    setUploadDisabled((prev) => {
      return { ...prev, [index]: true };
    });
  };

  const removePendingFile = (i: number) => {
    setPendingFiles((prev) => prev.filter((_, idx) => idx !== i));
    setUploadDisabled((prev) => ({ ...prev, [index]: false }));
  };

  /* const handleProjectSubmit = (
    e: React.FormEvent<HTMLFormElement>,
    index: number,
  ) => {
    e.preventDefault();

    if (projects.length === undefined) {
      return;
    }

    setSavePortfolioButton(true);
    setTimeout(() => {
      scrollToPortfolioButton();
    }, 0);

    setPortfolioData((prev) => ({ ...prev, projects }));
    toast.success(`your project hasn't been saved yet, to saved you are encouraged to click the 'save portfolio' button to apply.`);
    setOpenedPopups((prev) => {
      const newProjectsPopups = [...prev.projects];
      newProjectsPopups[index] = false;
      return {
        ...prev,
        projects: newProjectsPopups,
      };
    });
  }; */
  const handleProjectSubmit = async (e: React.FormEvent<HTMLFormElement>, index: number) => {
    e.preventDefault();
    const projectId = projects[index]?.id;
    if (!portfolioId || !projectId) {
      toast.error('Project could not be saved.');
      return;
    }

    setIsSubmitting(true);
    try {
      const current = projects[index];
      const visibility = resolveProjectVisibility(current);
      const patchBody = {
        name: current.name?.trim(),
        description: current.description?.trim() || '',
        visibility,
        isHiddenOnPublic: visibility !== 'public',
      };

      const response = await axiosInstance.patch(
        API_ROUTES.PORTFOLIO.PATCH_PROJECT(projectId),
        patchBody
      );

      if (!response || response.status >= 300) {
        throw new Error(`Save failed (${response?.status})`);
      }

      const savedProject = response.data?.project;
      if (pendingFiles.length > 0) {
        for (const file of pendingFiles) {
          const fileId = uuidv4();
          const fd = new FormData();
          fd.append('info', JSON.stringify({ project: { id: projectId, fileId } }));
          fd.append(fileId, file, file.name);
          await axiosInstance.post(API_ROUTES.PORTFOLIO.UPLOAD_FILES, fd);
        }
      }

      const updatedProjects = [...projects];
      updatedProjects[index] = {
        ...updatedProjects[index],
        ...(savedProject || patchBody),
        filesUrl: [...(updatedProjects[index].filesUrl || []), ...pendingFiles.map((f) => f.name)],
      };
      setProjects(updatedProjects);
      setPortfolioData((prev) => ({
        ...prev,
        projects: updatedProjects as typeof prev.projects,
      }));

      await refreshPortfolioAfterSave(
        setPortfolioData,
        {
          projects: updatedProjects as ReturnedPortfolio['projects'],
        },
        getData
      );

      toast.success('Project updated');
      setPendingFiles([]);
      setDisabled(true);
      setOpenedPopups((prev) => {
        const newProjectsPopups = [...prev.projects];
        newProjectsPopups[index] = false;
        return { ...prev, projects: newProjectsPopups };
      });
    } catch (err: any) {
      console.error(err);
      toast.error(err?.message || 'Failed to update project');
    } finally {
      setIsSubmitting(false);
    }
  };

  /* const findNewProject = (
    savedPortfolio: any,
    beforeIds: Set<string>,
    staged: any,
  ) => {
    const created = savedPortfolio.projects.find(
      (p: any) => !beforeIds.has(p.id),
    );
    if (created) return created;

    // Fallback: match by fields if IDs are reshuffled
    return savedPortfolio.projects.find(
      (p: any) =>
        p.name === staged.name &&
        (p.description ?? null) === (staged.description ?? null) &&
        (p.link ?? null) === (staged.link ?? null),
    );
  }; */

  /*   const handleSubmitOfNewProject = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const updatedProjects = [...projects, project];

      setPortfolioData((prev) => ({ ...prev, projects: updatedProjects }));
      setSavePortfolioButton(true);
      setTimeout(() => {
        scrollToPortfolioButton();
      }, 0);

      setPopupsToAdd((prev: PopupsForAddingState) => ({
        ...prev,
        projects: false,
      }));
    } catch (err) {
      console.error(err);
      toast.error('Failed to add project');
    }
  }; */

  const handleSubmitOfNewProject = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Track old ids first
      const existingIds = new Set((portfolio.projects || []).map((p: any) => p.id));

      // Stage the project
      const stagedVisibility = resolveProjectVisibility(project);
      const stagedProject = {
        clientUuid: uuidv4(), // 🔑 temp unique key
        id: undefined,
        name: project.name?.trim(),
        description: project.description?.trim() || null,
        link: normalizeUrl(project.link),
        links: Array.isArray(project.links) ? project.links.map(normalizeUrl).filter(Boolean) : [],
        filesUrl: [],
        visibility: stagedVisibility,
        isHiddenOnPublic: stagedVisibility !== 'public',
        is_hidden_on_public: stagedVisibility !== 'public',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };

      if (!stagedProject.name) {
        toast.error('Project name is required');
        return;
      }

      // Build payload
      const info = {
        ...portfolio,
        projects: [...(portfolio.projects || []), stagedProject],
      };

      // Send payload
      const form = new FormData();
      form.append('info', JSON.stringify(info));

      const url = `${API_ROUTES.PORTFOLIO.EDIT_PORTFOLIO}/${portfolioId}`;
      const saveRes = await axiosInstance.post(url, form);

      if (!saveRes || saveRes.status >= 300) {
        throw new Error(`Save failed (${saveRes?.status})`);
      }

      const savedPortfolio = saveRes.data.portfolio;

      // ✅ Find the project with a *new id*
      const created = savedPortfolio.projects.find(
        (p: any) => !existingIds.has(p.id) && p.name === stagedProject.name
      );

      if (!created?.id) {
        throw new Error('Could not identify newly created project id');
      }

      // ✅ Upload files only when new id exists
      if (pendingFiles.length > 0) {
        for (const file of pendingFiles) {
          const infoForUpload = {
            project: { id: created.id, fileId: uuidv4() },
          };
          const fd = new FormData();
          fd.append('info', JSON.stringify(infoForUpload));
          fd.append(infoForUpload.project.fileId, file, file.name);
          await axiosInstance.post(API_ROUTES.PORTFOLIO.UPLOAD_FILES, fd);
        }
      }

      toast.success('Project added');
      setPendingFiles([]);
      setNewProject(created);
      setPopupsToAdd((prev) => ({ ...prev, projects: false }));
      /* setSavePortfolioButton(true);
      setTimeout(() => {
        scrollToPortfolioButton();
      }, 0); */

      await refreshPortfolioAfterSave(setPortfolioData, savedPortfolio, getData);
    } catch (err: any) {
      console.error(err);
      toast.error(err?.message || 'Failed to add project');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteFile = (projectIndex: number, fileIndex: number, fileItem: any) => {
    if (fileItem instanceof File) {
      // File is newly added (pending)
      setPendingFiles((prev) => prev.filter((_, idx) => idx !== fileIndex));
      setUploadDisabled((prev) => ({ ...prev, [projectIndex]: false }));
      toast.success('Pending file removed');
    } else {
      // File exists in DB → stage deletion
      const updatedFiles = projects[projectIndex].filesUrl.filter(
        (_: any, index: number) => index !== fileIndex
      );

      const updatedItem = {
        ...projects[projectIndex],
        filesUrl: updatedFiles,
      };

      const updatedItems = [...projects];
      updatedItems[projectIndex] = updatedItem;

      setUploadDisabled((prev) => ({ ...prev, [projectIndex]: false }));

      setProjects(updatedItems);
      setDisabled(false);
    }
  };

  const handleInputChange = (
    index: number,
    field: string,
    value: string,
    array: any,
    setItems: React.Dispatch<React.SetStateAction<any>>
  ) => {
    const itemIndex = array.findIndex((_: any, prIndex: number) => prIndex === index);

    if (itemIndex !== -1) {
      const updatedItems = [...array];
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        [field]: value,
      };
      setItems(updatedItems);
      setDisabled(false);
      /* setSavePortfolioButton(true);
      setTimeout(() => {
        scrollToPortfolioButton();
      }, 0); */
    }
  };

  /* const handleFileChange = async (index: number, file: File, array: any[]) => {
    const maxSizeInBytes = 10 * 1024 * 1024;

    if (file.size >= maxSizeInBytes) {
      setSizeError(true);
      return;
    }

    const data: FormData = new FormData();

    const info = {
      project: { id: array[index].id, fileId: uuidv4() },
    };

    data.append('info', JSON.stringify(info));

    data.append(info.project.fileId, file, file.name);

    try {
      const response = await axiosInstance.post(
        API_ROUTES.PORTFOLIO.UPLOAD_FILES,
        data,
      );

      if (!response || response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // setAddingFileSuccess(true);
      await response.data;
      getData();
      toast.success('File successfully uploaded');
    } catch (error) {
      toast.error('Failed to upload file');
      console.error('Failed to upload portfolio files:', error);
    }
  }; */

  const handleFileChange = (index: number, file: File) => {
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (file.size >= maxSizeInBytes) {
      setSizeError(true);
      return;
    }

    // Just put filename string in filesUrl (safe for JSON / trim)
    // const updatedProjects = [...projects];
    // updatedProjects[index] = {
    //   ...updatedProjects[index],
    //   filesUrl: [
    //     ...(updatedProjects[index].filesUrl || []),
    //     file.name, // ✅ string only
    //   ],
    // };

    // setProjects(updatedProjects);

    // Keep the actual file for later upload
    setPendingFiles((prev) => [...prev, file]);

    setDisabled(false);
    setSizeError(false);
    setUploadDisabled((prev) => {
      return { ...prev, [index]: true };
    });
  };

  return (
    <Card
      className={`${popupVariant === 'adding' ? '' : 'user-popup'} p-0 popup-card`}
      ref={popupRef}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Card.Header className="popup-header">
        <div className="header-icon">📁</div>
        <div>
          <div className="header-title">
            {popupVariant === 'adding' ? 'Add Project' : 'Edit Project'}
          </div>
        </div>
      </Card.Header>

      <Card.Body className="scrollable-card">
        {popupVariant === 'adding' ? (
          // ---------- ADD PROJECT ----------
          <Form onSubmit={(e) => handleSubmitOfNewProject(e)}>
            {/* Name */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col xs={12}>
                  <Form.Control
                    type="text"
                    required
                    placeholder="Enter a name"
                    onChange={(e) => handleNewItemFields('name', e.target.value, setNewProject)}
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Description */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col xs={12} style={{ position: 'relative' }}>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    required
                    maxLength={50}
                    className="popup-textarea"
                    placeholder="Enter a description"
                    onChange={(e) =>
                      handleNewItemFields('description', e.target.value, setNewProject)
                    }
                  />
                  <span className="textarea-placeholder">Max: 50 characters</span>
                </Col>
              </Form.Group>
            </div>

            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col xs={12}>
                  <ProjectVisibilityField
                    value={resolveProjectVisibility(project)}
                    onChange={(next) =>
                      setNewProject((prev: any) => setProjectVisibility(prev, next))
                    }
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Files (ADD) */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col xs={12}>
                  <div className="file-chip-wrap">
                    {pendingFiles.map((f, i) => (
                      <span key={i} className="file-chip" title={f.name}>
                        <span className="file-dot" />
                        <span className="file-chip-text">
                          {f.name.length > 34
                            ? `${f.name.slice(0, 20)}…${f.name.slice(-10)}`
                            : f.name}
                        </span>
                        <button
                          type="button"
                          className="chip-remove"
                          onClick={() => removePendingFile(i)}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>

                  <FileUploadComponent
                    key={pendingFiles.length} // helps re-open after remove
                    handleFileChange={(file: File) => {
                      if (pendingFiles.length >= 1) {
                        toast.error('You can only upload one file at a time');
                        return;
                      }
                      handleSelectFileForNew(file);
                    }}
                    disabled={pendingFiles.length >= 1} // simple rule for add
                  />
                  <small className="text-muted d-block mt-1">Max file size: 10MB</small>
                  {sizeError && <Alert variant="danger">File exceeds 10MB limit</Alert>}
                </Col>
              </Form.Group>
            </div>

            {/* Actions */}
            <div className="sticky-actions">
              <Button
                variant="outline-secondary"
                onClick={() => setPopupsToAdd((prev) => ({ ...prev, projects: false }))}
              >
                Cancel
              </Button>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Submitting...
                  </>
                ) : (
                  'Submit'
                )}
              </Button>
            </div>
          </Form>
        ) : (
          // ---------- EDIT PROJECT ----------
          <Form onSubmit={(e) => handleProjectSubmit(e, index)}>
            {/* Project Name */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column xs={12}>
                  Project Name
                </Form.Label>
                <Col xs={12}>
                  <Form.Control
                    type="text"
                    required
                    defaultValue={portfolio.projects[index].name}
                    onChange={(e) =>
                      handleInputChange(index, 'name', e.target.value, projects, setProjects)
                    }
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Description */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column xs={12}>
                  Description
                </Form.Label>
                <Col xs={12} style={{ position: 'relative' }}>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    className="popup-textarea"
                    required
                    maxLength={200}
                    defaultValue={portfolio.projects[index].description}
                    onChange={(e) =>
                      handleInputChange(index, 'description', e.target.value, projects, setProjects)
                    }
                  />
                  <span className="textarea-placeholder">Max: 200 characters</span>
                </Col>
              </Form.Group>
            </div>

            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Col xs={12}>
                  <ProjectVisibilityField
                    value={resolveProjectVisibility(projects[index])}
                    onChange={(next) => {
                      const updatedProjects = [...projects];
                      updatedProjects[index] = setProjectVisibility(updatedProjects[index], next);
                      setProjects(updatedProjects);
                      setDisabled(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </div>

            {/* Files (EDIT) */}
            <div className="section">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column xs={12}>
                  Upload Supporting Files
                </Form.Label>
                <Col xs={12} className="file-upload-section">
                  <div className="file-chip-wrap">
                    {[...(projects[index].filesUrl || []), ...(pendingFiles || [])].map(
                      (fileItem: any, fileIndex: number) => {
                        const fileName =
                          fileItem?.name ||
                          fileItem?.file?.name ||
                          fileItem.toString().replace(/_/g, ' ').split('/').pop();

                        return (
                          <span key={fileIndex} className="file-chip" title={fileName}>
                            <span className="file-dot" />
                            <span className="file-chip-text">
                              {fileName.length > 34
                                ? `${fileName.slice(0, 20)}…${fileName.slice(-10)}`
                                : fileName}
                            </span>
                            <button
                              type="button"
                              className="chip-remove"
                              onClick={() => handleDeleteFile(index, fileIndex, fileItem)}
                            >
                              ×
                            </button>
                          </span>
                        );
                      }
                    )}
                  </div>

                  {projects[index].filesUrl.length + pendingFiles.length < 2 && (
                    <div className="select-project-file">
                      <FileUploadComponent
                        handleFileChange={(file: File) => {
                          const total =
                            (projects[index]?.filesUrl?.length || 0) + pendingFiles.length;
                          if (total >= 1) {
                            toast.error('You can only upload one file at a time');
                            return;
                          }
                          handleFileChange(index, file);
                        }}
                        disabled={uploadDisabled[index]}
                      />
                      <small className="text-muted d-block mt-1">Max file size: 10MB</small>
                    </div>
                  )}

                  {fileError && <Alert variant="danger">{fileError}</Alert>}
                  {sizeError && (
                    <Alert variant="danger">{validationMessages.FILES_EXCEEDED_LIMIT_10MB}</Alert>
                  )}
                </Col>
              </Form.Group>
            </div>

            {/* Actions */}
            <div className="sticky-actions">
              <Button
                variant="outline-secondary"
                onClick={() =>
                  setOpenedPopups((prev) => {
                    const newProjectsPopups = [...prev.projects];
                    newProjectsPopups[index] = false;
                    return { ...prev, projects: newProjectsPopups };
                  })
                }
              >
                Cancel
              </Button>
              <Button variant="success" type="submit" disabled={disabled || isSubmitting}>
                {isSubmitting ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Submitting...
                  </>
                ) : (
                  'Submit'
                )}
              </Button>
            </div>
          </Form>
        )}
      </Card.Body>
    </Card>
  );
};

export default ProjectsPopup;
